const IITChallanges: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <p className="mb-4">
                <b>Indonesia Innovative Technology Challenge (IIT Challenge) 2024</b> kembali hadir sebagai ajang prestisius yang mempertemukan pelajar berbakat dari berbagai penjuru Indonesia dalam bidang teknologi dan inovasi.
            </p>

            <p className="mb-4">
                Dengan semangat membangun generasi unggul, IIT Challenge 2024 menghadirkan berbagai kategori lomba seru dan menantang yang dapat diikuti oleh siswa dari jenjang SMP hingga SMA.
            </p>

            <h2 className="text-2xl font-bold mb-4 mt-6">📌 IIT Challenge 2024 mengadakan beberapa lomba, yaitu:  </h2>
            <ul className="list-disc pl-6 mb-6 space-y-2">
                <li><b>Coding Junior</b> – untuk siswa SMP yang ingin menguji kemampuan logika dan pemrograman dasar.</li>
                <li><b>Coding Senior</b> – tantangan lanjutan bagi siswa SMA dalam mengembangkan solusi berbasis kode.</li>
                <li><b>Sumo Game</b> – kompetisi robot adu dorong yang seru dan penuh strategi.</li>
                <li><b>Innovative Junior</b> – ajang ide kreatif siswa SD untuk menciptakan solusi teknologi sederhana.</li>
                <li><b>Innovative Senior</b> – kategori inovasi tingkat SMP dengan pendekatan riset dan prototyping.</li>
                <li><b>Obstacle Robot</b> – robot dikendalikan untuk menyelesaikan rintangan dan misi tertentu secara otomatis.</li>
                <li><b>Student Symposium</b> – forum ilmiah untuk siswa mempresentasikan karya atau hasil penelitian mereka.</li>
            </ul>

            <p className='mb-8'>
                <b>IIT Challenge 2024</b> bukan hanya sekadar kompetisi, melainkan wadah untuk berinovasi, belajar, dan tumbuh bersama. Ayo dukung terus semangat generasi muda Indonesia dalam menciptakan masa depan teknologi yang gemilang!
            </p>
        </div>
    )
}
export default IITChallanges
